// Waveform Loader - Clean & Sleek Loading Circle
import React from 'react';

interface WaveformLoaderProps {
  height?: number;
  className?: string;
}

export const WaveformLoader: React.FC<WaveformLoaderProps> = ({ 
  height = 120,
  className = ''
}) => {
  return (
    <div 
      className={`w-full flex items-center justify-center ${className}`}
      style={{ height: `${height}px`, minHeight: `${height}px` }}
      aria-label="Loading waveform"
    >
      <div className="relative">
        {/* Clean & Sleek Loading Circle */}
        <div
          className="w-12 h-12 rounded-full border-3 border-primary/20 border-t-primary animate-spin"
          style={{
            borderWidth: '3px',
          }}
        />
      </div>
    </div>
  );
};

